import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { ApprovalState } from './approval.model';
import { ApprovalStore } from './approval.store';

@Injectable({ providedIn: 'root' })
export class ApprovalQuery extends Query<ApprovalState> {
  protected store: ApprovalStore;

  constructor() {
    const store = inject(ApprovalStore);

    super(store);

    this.store = store;
  }
}
